'use strict';

wbApp.controller('SchedulerCtrl', ['$scope', '$timeout', 'tenantSettingSvc', 'semesterSvc', 'classroomSvc', 'urlUtils',
function ($scope, $timeout, tenantSettingSvc, semesterSvc, classroomSvc, urlUtils) {

    $scope.semesters = semesterSvc.getAllShowInAttendanceAsync();

    $scope.semesters.$promise.then(function () {
        prepareTabs();
        switchToCorrectTab();
        $timeout(function () {
            watchSemesterChanges();
        });
    });

    $scope.tenantSettings = tenantSettingSvc.settings;

    $scope.tabs = [];

    function prepareTabs() {
        for (var i = 0; i < $scope.semesters.length; i++) {
            var semester = $scope.semesters[i];
            $scope.tabs.push({ 
                title: semester.name,
                semesterID: semester.id,
                template: "schedule/semester-detail-tab.html",
            });
        }
    }

    function watchSemesterChanges() {
        $scope.$watch('tabs.activeTab', function (newValue) {
            $scope.semesters.$promise.then(function () {
                var semester = $scope.semesters[newValue];
                if (!!semester) {
                    urlUtils.setUrlParam("semesterID", semester.id);
                    $scope.$broadcast('semesterchanged', newValue, semester);
                }
            });
        });
    }

    function switchToCorrectTab() {
        var semesterIDStr = urlUtils.getQueryParams()['semesterID'];
        if (!!semesterIDStr) {

            var semesterID = Number(semesterIDStr);
            // find correct tab
            var tabIndexToActivate = _.findIndex($scope.tabs, { semesterID: semesterID });
            if (tabIndexToActivate !== -1 && $scope.tabs.activeTab !== tabIndexToActivate) {
                $scope.tabs.activeTab = tabIndexToActivate;
                return;
            }

        }

        urlUtils.setUrlParam("semesterID", null);
        $scope.tabs.activeTab = 0;
    }
}]);